import TrashIcon from "assets/icon/TrashIcon"

export default function DeleteButton(props){
    return(
        <button className={`button flex gap-2 items-center text-xs ${ props?.visible ? 'block' : 'hidden' }`} onClick={props?.onClick}>
            <TrashIcon className="fill-white w-5" />
            <span>Delete</span>
        </button>
    )
}